module.exports = __webpack_public_path__ + "img/drone1.png";